import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateUserRole } from '@/data/features/user/user';
import { useCheckAuthMutation } from '@/services/api';
import routes from '@/routes';

const useSessionChecker = () => {
  const dispatch = useDispatch();
  const [checkAuth] = useCheckAuthMutation();
  const accessToken = useSelector((state) => state.user?.accessToken);
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!accessToken) {
        setIsChecking(true);
        try {
          const { data } = await checkAuth();
          if (data?.isLoggedIn) {
            dispatch(updateUserRole({
              role: data.role,
              accessToken: data.accessToken,
              name: data.name,
              refreshToken: data.refreshToken,
              refreshTokenId: data.refreshTokenId,
            }));
            navigate(routes.main.path);
          }
        } finally {
          setIsChecking(false);
        }
      }
    };
    check();
  }, [accessToken, dispatch, checkAuth, navigate]);

  return isChecking;
};

export default useSessionChecker;
